var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidenavBot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_98_676)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.70957 12.97C7.70957 12.31 7.16957 11.77 6.50957 11.77C5.84957 11.77 5.30957 12.31 5.30957 12.97C5.30957 13.63 5.84957 14.17 6.50957 14.17C7.16957 14.17 7.70957 13.63 7.70957 12.97Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0896 11.77C10.4296 11.77 9.88965 12.31 9.88965 12.97C9.88965 13.63 10.4296 14.17 11.0896 14.17C11.7496 14.17 12.2896 13.63 12.2896 12.97C12.2896 12.31 11.7496 11.77 11.0896 11.77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.37 9.53C13.99 8.21 12.11 7.4 10.02 7.4H9.61V5.88C10.88 5.53 11.81 4.38 11.81 3C11.81 1.34 10.47 0 8.81 0C7.15 0 5.81 1.34 5.81 3C5.81 4.38 6.74 5.53 8.01 5.88V7.4H7.6C3.43 7.4 0 10.64 0 14.7C0 16.73 0.86 18.56 2.23 19.87C3.61 21.19 5.49 22 7.58 22H10.01C14.17 22 17.6 18.76 17.6 14.7C17.6 12.68 16.74 10.84 15.37 9.53ZM7.4 3C7.4 2.23 8.03 1.6 8.8 1.6C9.57 1.6 10.2 2.23 10.2 3C10.2 3.77 9.57 4.4 8.8 4.4C8.03 4.4 7.4 3.77 7.4 3ZM10.01 20.4H7.58C5.91 20.4 4.42 19.76 3.33 18.72C2.25 17.68 1.59 16.27 1.59 14.7C1.59 11.58 4.24 9 7.58 9H10.01C11.68 9 13.17 9.64 14.26 10.68C15.34 11.72 16 13.14 16 14.7C16 17.82 13.35 20.4 10.01 20.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2796 16.19C9.8796 16.53 9.3696 16.73 8.7896 16.73C8.2096 16.73 7.7196 16.53 7.3096 16.2C6.9696 15.92 6.4696 15.96 6.1796 16.3C5.8996 16.64 5.9396 17.14 6.2796 17.43C6.9596 17.99 7.8196 18.34 8.7796 18.34C9.7396 18.34 10.6196 18 11.3096 17.42C11.6496 17.13 11.6896 16.63 11.3996 16.29C11.1096 15.95 10.6096 15.91 10.2696 16.2L10.2796 16.19Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_98_676"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.6,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidenavBot);
export default __webpack_public_path__ + "static/media/sidenav-bot.99764a85a0fff8b44666adf9424b9ae8.svg";
export { ForwardRef as ReactComponent };